import { useDispatch } from 'react-redux';
import { useState, useEffect } from 'react';
import { t } from 'react-switch-lang';
import style from '../../styles/Reports.module.scss';
import { REPORTS } from '../../utils/Constants';
import { useRouter } from '../Router';
import { clearAllReportData } from '../../redux/actions/ReportActions';
import { events, logAmpEvent } from '../../utils/Amplitude';
import PaymentsReport from './PaymentsReport';

function ReportsTab({ title, active, onClick, ariaLabel, reportType }) {
  return (
    <button
      type="button"
      className={`${style.reportTab} ${active && style.active}`}
      aria-label={ariaLabel}
      onClick={() => {
        onClick();
        logAmpEvent(
          events.USER_CLICKED_REPORT_TAB,
          { Tab: reportType }
        );
      }}
    >
      <h2>{t(title)}</h2>
    </button>
  );
}

function Reports() {
  const router = useRouter();
  const queryParamReport = router.query.report?.toLowerCase();
  const [activeTab, setActiveTab] = useState(queryParamReport || REPORTS.PAYMENTS);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!router.isReady || !router.query.partner) return;
    const report = !queryParamReport || !REPORTS[queryParamReport.toUpperCase()] ?
      REPORTS.PAYMENTS.toLowerCase() : queryParamReport;

    router.replaceStatic({
      pathname: router.pathname,
      // Updates report query parameter to lowercase
      query: { ...router.query, report },
    }, undefined, { shallow: true });
    setActiveTab(report);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [router.query.partner]);

  useEffect(() => () => dispatch(clearAllReportData()), [dispatch]);

  function isActiveTab(report) {
    return activeTab?.toLowerCase() === report.toLowerCase();
  }

  function handleTabSelect(report) {
    if (isActiveTab(report)) return;
    router.replaceStatic({
      pathname: router.pathname,
      query: { ...router.query, report: report.toLowerCase() },
    }, undefined, { shallow: true });
    setActiveTab(report);
  }

  return (
    <div className={style.reportsContainer}>
      <div className={style.reportsTabsContainer}>
        <ReportsTab
          title={t('Reports_Payments_Title')}
          active={isActiveTab(REPORTS.PAYMENTS)}
          reportType={REPORTS.PAYMENTS}
          onClick={() => {
            handleTabSelect(REPORTS.PAYMENTS);
          }}
          ariaLabel={t('Reports_PaymentsTab_Description')}
        />
      </div>
      <div className={style.reportContentsContainer}>
        {isActiveTab(REPORTS.PAYMENTS) && <PaymentsReport />}
      </div>
    </div>
  );
}

export default Reports;
